import mExpr from "math-expression-evaluator";
import { Parser } from 'expr-eval'
import moment from 'moment';
import { ApiCore } from '../../../api';
const api = new ApiCore();
export default {

    // 处理逻辑运算
    handleLogicOperations(logicOperation, savedValues, data, propsData) {
        if ((!savedValues || savedValues.length === 0 ) && !propsData?.globalValues?.length ) {
            return 'null';
        }
        switch (logicOperation.type) {
            case "expr":

                return this.handleExpr(logicOperation.rule, logicOperation.target, savedValues, data, propsData);
            case "rangeCalc":
                this.handleRangeCalc(logicOperation.standard, logicOperation.target, savedValues, data);
                break;
            case "toAge":
                return this.handleToAge(logicOperation.target, savedValues, data);
                break;
            case "rangStandards":
                this.handleRangStandards(logicOperation.table, logicOperation.target, savedValues, data);
                break;
            case "dynamicValue":
                return this.handleDynamicValue(logicOperation.target, savedValues, data);
            case "dateExpr":
                return this.handleDateExpr(logicOperation.rule, logicOperation.target, savedValues, data,  propsData);
            default:
                break;
        }
    },

    /**
     * 范围计算
     * @param rule
     * @param target
     * @param _this
     */
    handleRangeCalc(standard, target, savedValues, data) {
        if (standard === null || standard.length === 0) {
            return;
        }

        let currValue = null;
        let targetValue = null;
        for (let itemData of savedValues) {
            if (itemData.dataCode == target) {
                targetValue = itemData.value * 1;
            }
            if (itemData.dataCode == data.dataCode) {
                currValue = itemData.value;
            }
        }
        if (!targetValue) {
            return;
        }

        for (let item of standard) {
            if (item["gt"] && item["gt"] >= targetValue) {
                continue;
            }
            if (item["gte"] && item["gte"] > targetValue) {
                continue;
            }
            if (item["lt"] && item["lt"] <= targetValue) {
                continue;
            }
            if (item["lte"] && item["lte"] < targetValue) {
                continue;
            }
            if (item["eq"] && item["eq"] !== targetValue) {
                continue;
            }
            if (item["ne"] && item["ne"] === targetValue) {
                continue;
            }
            if (currValue === item["result"]) {
                return;
            }

            let tag = true;
            for (let value of savedValues) {
                if (value.dataCode == data.dataCode) {
                    value.value = item["result"];
                    tag = false;
                }
            }
            if (tag) {
                savedValues.push({
                    deCode: data.deCode,
                    dataCode: data.dataCode,
                    value: item["result"]
                });
            }
        }

        return "null";
    },

    /**
     * 公式计算
     * @param rule
     * @param target
     * @param _this
     * @returns {string}
     */

    // handleExpr(rule, target, savedValues, data) {
    //     console.log("form=====",savedValues,target,data)

    //     let currValue = null;
    //     for (let key of target) {
    //         let value = null;
    //         for (let item of savedValues) {
    //             if (item.dataCode == key) {
    //                 if (!Array.isArray(item.value)) {
    //                     value = item.value;
    //                 } else {
    //                     // input-select ['', ''] // 前者input输入框内容，后者分数
    //                     value =  item.value[1] || '';
    //                 }
    //             }
    //             if (item.dataCode == data.dataCode) {
    //                 if (!Array.isArray(item.value)) {
    //                     currValue = item.value;
    //                 } else {
    //                     // input-select ['', ''] // 前者input输入框内容，后者分数
    //                     currValue =  item.value[1] || '';
    //                 }
    //             }
    //         }
    //         if (value == null || value === "" || isNaN(value)) {
    //             return "null";
    //         }
    //         rule = rule.replaceAll(key, value);
    //     }

    //     let maxPrecision = 2;
    //     if (data.validationRules) {
    //         for (let rule of data.validationRules) {
    //             if (rule.condition == "maxPrecision" && rule.type == "range") {
    //                 maxPrecision = rule.rule * 1;
    //             }
    //         }
    //     }

    //     let result = mExpr.eval(rule) + "";
    //     // 有小数点时
    //     if (result.indexOf(".") >= 0) {
    //         let length = result.indexOf(".") + maxPrecision + 1;
    //         length = length > result.length ? result.length : length;
    //         result = result.substr(0, length);
    //     }

    //     if (currValue == result) {
    //         return;
    //     }

    //     let reCorrectValues = []; // 自动计算的，但是手动修改后，仍然要保持自动计算的值的
    //     let tag = false;
    //     for (let item of savedValues) {
    //         if (item.dataCode == data.dataCode) {
    //             item.value = result;
    //             tag = true;
    //             reCorrectValues.push({
    //                 ...item,
    //                 value: result
    //             });
    //         }
    //     }
      
    //     if(!tag){
    //         savedValues.push({
    //             deCode: data.deCode,
    //             dataCode: data.dataCode,
    //             value: result
    //         });
    //         // 第一次没有这个属性，则加上这个属性
    //         reCorrectValues.push({
    //             deCode: data.deCode,
    //             dataCode: data.dataCode,
    //             value: result
    //         });
    //     }
    //     if (reCorrectValues.length > 0) {
    //         return reCorrectValues;
    //     }
    // },
    handleExpr(rule, target, savedValues, data, propsData, visit) { 
        // propsData 为了计算，从全局获取值
        console.log("rule=====",rule,savedValues, target, data, propsData)
        let currValue = null;
        let num = 0;
        let result = null;
        for (let key of target) {
            let value = null;
            // 针对带#的和不带#的，然后优先从savedValues,再从全局里面取
            if(key.indexOf('#') != -1){
                if(data.dataCode.indexOf('#') != -1){
                    let Index = data.dataCode.split('#')[1];
                    const newKey = `${key.split('#')[0]}#${Index}`;
                    const findIndex = savedValues.findIndex(item=>item.dataCode == newKey);
                    if(findIndex > -1){
                        const item = savedValues[findIndex]
                        if (item.dataCode == newKey) {
                           //兼容 input-select ['', ''] 改为 {other: '', radio: '', min: '', max: ''}
                            if(item.value !== null && typeof item.value === 'object'){
                                value = item.value.radio
                            
                            }else{
                                value = item.value;
                            }
                        }
                    }else{
                        // const arr =  (propsData?.globalValues|| []).filter(s =>s.dataCode === newKey )
                        // if(arr?.length){
                        //     value = arr[arr.length-1].value
                        //     if(value !== null && typeof value === 'object'){
                        //         value = value.radio
                        //     }
                        // }
                    }
                }
                
            }else{
                const findIndex =  savedValues.findIndex(item=>item.dataCode == key);
                if(findIndex > -1){
                    const item = savedValues[findIndex]
                    if (item.dataCode == key) {
                          //兼容 input-select ['', ''] 改为 {other: '', radio: '', min: '', max: ''}
                        if(item.value !== null && typeof item.value === 'object'){
                            value = item.value.radio
                        
                        }else{
                            value = item.value;
                        }
                    }

                }else{
                    // 在saveValued找不到的情况，从全局里面找
                    // const arr = (propsData?.globalValues || []).filter(s => s.dataCode === key )
                    // if(arr?.length){
                    //     value = arr[arr.length-1].value;
                    //     if(value !== null && typeof value === 'object'){
                    //         value = value.radio
                    //     }
                    // }
                }
            }
           for (let item of savedValues) {
               
                if (item.dataCode == data.dataCode) {
                    currValue = item.value;
                    if(currValue == null || typeof currValue !== 'object'){
                        currValue = item.value;
                    }else{
                        //兼容 input-select {other: '', radio: '', min: '', max: ''}
                        currValue = item.value.radio
                    }
                }
            }
            if ((value == null || value === "" || isNaN(value))) {
                // 计算值的参数值为空，那么currentValue应该也为空；如果有值则手动置空
                if(!currValue){
                    return "null";
                } else{
                    num++
                }
            }
     
            rule = rule.replaceAll(key, value);
        }
       
        let maxPrecision = 2;
        if (data.validationRules) {
            for (let rule of data.validationRules) {
                if (rule.condition == "maxPrecision" && rule.type == "range") {
                    maxPrecision = rule.rule * 1;
                }
            }
        }
        try {
        
            result = num? "": (mExpr.eval(rule) + "") ;
        
            
            // 有小数点时
            if (result.indexOf(".") >= 0) {
                let length = result.indexOf(".") + maxPrecision + 1;
                length = length > result.length ? result.length : length;
                result = result.substr(0, length);
            }

            if (currValue == result) {
                return "null";
            }

            let reCorrectValues = []; // 自动计算的，但是手动修改后，仍然要保持自动计算的值的
            let tag = false;
            for (let item of savedValues) {
                if (item.dataCode == data.dataCode) {
                    item.value = result;
                    tag = true;
                    reCorrectValues.push({
                        ...item,
                        value: result
                    });
                }
            }
        
            if(!tag){
                savedValues.push({
                    deCode: data.deCode,
                    dataCode: data.dataCode,
                    value: result
                });
                // 第一次没有这个属性，则加上这个属性
                reCorrectValues.push({
                    deCode: data.deCode,
                    dataCode: data.dataCode,
                    value: result
                });
            }
            if (reCorrectValues.length > 0) {
                return reCorrectValues;
            }
                
        } catch (error) {
            // 对于一些不规则计算，跳过，比如参数11.
            return "null" 
        }
    },
    /**
     * 年龄计算
     * @param target
     * @param _this
     */
    handleToAge(target, savedValues, data) {
        console.log(target,savedValues, data)

        let targetValue = null;
        let currValue = null;
        for (let item of savedValues) {
            if (item.dataCode == target) {
                targetValue = item.value;
            }
            if (item.dataCode == data.dataCode) {
                currValue = item.value;
            }
        }

        let result = null;
        if (!targetValue || new Date(targetValue) == 'Invalid Date') {
            result = ""
        }else{
            result = this.getAge(moment(new Date(targetValue)).format('YYYY-MM-DD'))
        }

        if (currValue == result) {
            return "null";
        }
        let reCorrectValues = []; // 自动计算的，但是手动修改后，仍然要保持自动计算的值的
        let tag = true;
        for (let item of savedValues) {
            console.log(item.dataCode == data.dataCode)
            if (item.dataCode == data.dataCode) {
                item.value = result;
                tag = false;
                reCorrectValues.push({
                    ...item,
                    value: result
                });
            }
        }
        

        let localStorage_forms = localStorage.getItem('localStorage_forms');
        if (localStorage_forms) {
            let forms = JSON.parse(localStorage_forms);
            const params = {
                formId: forms.activeId,
                submit: false,
                values: [{
                    deCode: data.deCode,
                    dataCode: data.dataCode,
                    value: result
                }]
            }
            api.saveForm(params);
        }

  
        if(tag){
            savedValues.push({
                deCode: data.deCode,
                dataCode: data.dataCode,
                value: result
            });
            // 第一次没有这个属性，则加上这个属性
            reCorrectValues.push({
                deCode: data.deCode,
                dataCode: data.dataCode,
                value: result
            });
        }

        
        if (reCorrectValues.length > 0) {
            return reCorrectValues;
        }
     
    },
    /**
     * 界值表计算   
     * 通过指定数据的值，自动进行范围计算，并展示出对应结果   
     * @param target
     * @param _this
     */
    handleRangStandards(table, target, savedValues, data) {
        console.log(savedValues)
        if (table === null || table.length === 0) {
            return
        }
        let currValue = null;
        let targetValue = null;
        for (let item of savedValues) {
            if (item.dataCode == target) {
                targetValue = item.value;
            }
            if (item.dataCode == data.dataCode) {
                currValue = item.value;
            }
        }

        if (!targetValue) {
            return
        }
        let result = ''
        for (let index = 0; index < table.length; index++) {
            const item = table[index];
            if (item.condition == 'eq' && (targetValue == Number(item.rule))) {
                result = item.result
                break
            } else if (item.condition == 'lt' && (targetValue < Number(item.rule))) {
                result = item.result
                break
            } else if (item.condition == 'lte' && (targetValue <= Number(item.rule))) {
                result = item.result
                break
            } else if (item.condition == 'gt' && (targetValue > Number(item.rule))) {
                result = item.result
                break
            } else if (item.condition == 'gte' && (targetValue >= Number(item.rule))) {
                result = item.result
                break
            }
        }

        if (currValue == result) {
            return;
        }
        let tag = true;
        for (let item of savedValues) {
            if (item.dataCode == data.dataCode) {
                item.value = result;
                tag = false;
            }
        }
        if (tag) {
            savedValues.push({
                deCode: data.deCode,
                dataCode: data.dataCode,
                value: result
            });
        }
    },
    /**
     * 通过指定目标字段，将目标字段的值自动复制给当前表单
     * 如果当前字段值为空时，接受动态值，只要这个字段有值，就不接受动态值
     * @param target
     * @param _this
     */
    handleDynamicValue(target, savedValues, data) {
        let currValue = null;
        let targetValue = null;
        for (let item of savedValues) {

            if (data.dataCode.indexOf('#') != -1) {
                let Index = data.dataCode.split('#')[1]
                if (target.indexOf('#{index}') != -1) {
                    target = `${target.split('#')[0]}#${Index}`
                }
            }

            if (item.dataCode == target) {
                targetValue = item.value;
            }
            if (item.dataCode == data.dataCode) {
                currValue = item.value;
            }
        }

        if (!targetValue) {
            return "null"
        }
        if (currValue) {
            return "null"
        }

        let result = ''
        if (targetValue instanceof Array) {
            if (data.optional) {
                for (const key in data.optional) {
                    let Index = targetValue.findIndex((item) => item == key)
                    if (Index > -1) {
                        result = key
                    }
                }
            }
        } else {
            result = targetValue
        }


        if (currValue == result) {
            return "null";
        }
        let tag = true;
        for (let item of savedValues) {
            if (item.dataCode == data.dataCode) {
                item.value = result;
                tag = false;
            }
        }
        if (tag) {
            savedValues.push({
                deCode: data.deCode,
                dataCode: data.dataCode,
                value: result
            });
        }
    },


    /**
     * 根据出生日期获取年龄
     * @param {*} strBirthday 出生日期  2010-01-01
     * @returns 
     */
    getAge(strBirthday) {
        let returnAge;

        let strBirthdayArr = strBirthday.split("-");
        let birthYear = strBirthdayArr[0];
        let birthMonth = strBirthdayArr[1];
        let birthDay = strBirthdayArr[2];

        let d = new Date();
        let nowYear = d.getFullYear();
        let nowMonth = d.getMonth() + 1;
        let nowDay = d.getDate();

        if (nowYear == birthYear) {
            returnAge = '0';//同年 则为0岁
        }
        else {
            var ageDiff = nowYear - birthYear; //年之差
            if (ageDiff > 0) {
                if (nowMonth == birthMonth) {
                    var dayDiff = nowDay - birthDay;//日之差
                    if (dayDiff < 0) {
                        returnAge = ageDiff - 1;
                    } else {
                        returnAge = ageDiff;
                    }
                } else {
                    var monthDiff = nowMonth - birthMonth;//月之差
                    if (monthDiff < 0) {
                        returnAge = ageDiff - 1;
                    } else {
                        returnAge = ageDiff;
                    }
                }
            }
            else {
                returnAge = '0';//出生日期不能大于今天
            }
        }
        return returnAge;
    },

     /**
     * 采血时间差值计算
     */
     handleDateExpr(rule, target, savedValues, data, propsData, visit) {
  
          // 先判断#，然后savedValues寻找，找不到就到全局里面找数据来计算（取最新的）
          let findTargetValue = null;
          let currValue = (savedValues ?? []).find(s => s.dataCode === data.dataCode)?.value;
          for (let [index, key] of target.entries()) {
              if (key.indexOf('#') != -1) {
                  // 带有索引的一一对应
                  if(data.dataCode.indexOf('#') != -1){
                      let Index = data.dataCode.split('#')[1];
                      const allValue = target[index] = `${key.split('#')[0]}#${Index}`;
                      findTargetValue = (savedValues ?? []).find(s => s.dataCode === allValue)?.value;
                  }
              }else{
                 findTargetValue = (savedValues ?? []).find(s => s.dataCode === key)?.value;
                //  if(!findTargetValue){
                //     const arr =  (propsData?.globalValues|| []).filter(s => (s.dataCode === key && s.visitName == visit))
                //     if(arr?.length){
                //       findTargetValue = arr[arr.length-1].value
                //    }       
                //  }
              }
              
              if (findTargetValue) {
                 const formatTimestamp = Math.floor(new Date(findTargetValue).getTime() / 1000) * 1000
                 rule = rule.replaceAll(key, formatTimestamp);
              } else {
                  return 'null'
              }
          }
        let maxPrecision = 2;
        if (data.validationRules?.length) {
            const rule = data.validationRules.find(rule => rule.condition == "maxPrecision" && rule.type == "range")
            maxPrecision = +rule.rule
        }
        let result ;
        // 针对不详，属于不规则时间，需要特殊处理
        if(rule.indexOf("NaN")>-1 ){
            if(currValue == "未知"){
                return result = 'null'
            }
             result = "未知"
        }else{
            result = mExpr.eval(rule);
            if (!Number.isInteger(result)) {
                result = result.toFixed(maxPrecision)
            }
            if (isNaN(result) || currValue == result) {
                return "null";
            }
        }
     
        let tag = true;
        for (let item of savedValues) {
            if (item.dataCode == data.dataCode) {
                item.value = result;
                tag = false;
                break;
            }
        }
        if (tag) {
            savedValues.push({
                deCode: data.deCode,
                dataCode: data.dataCode,
                value: result
            });
        }
    },

    /**
     * @description 满足任意条件时,返回对应的值
     * @param {*} conditions 条件表达式
     * @param {*} ctx 当前表单项的上下文
     * @returns 
     */
    setConditionalValue(ctx, savedValues) {
        if (!savedValues?.length) {
            return null;
        }
        const targetValue = (savedValues ?? []).find(s => s.dataCode === ctx.dataCode)?.value

        let result = null
        for(const c of (ctx?.conditionalValues ?? [])) {
            let emptyCount = 0
            const tokenObj = (c?.targets || []).reduce((acc, cur) => {
                let curValue = savedValues.find(s => s.dataCode === cur)?.value
                if (curValue === undefined || curValue === null) {
                    emptyCount += 1
                }
                if (c.type === 'number') {
                    curValue = curValue ? Number(curValue) : null
                }
                acc[cur] = curValue
                return acc
            }, {})

            if (emptyCount) {
                return null
            }
            const passed = Parser.evaluate(c.condition, tokenObj)
            if (passed) {
                result = c.value
                break;
            }
        }

        if (result === targetValue) {
            return null
        }
        return result
    },


}